<template>
  <div class="my-3">
    <hr class="text-dark">
    <p class="badge badge-pill badge-warning text-capitalize">{{ item.type }}</p>
    <div class="d-block">
      <b-icon class="bg-primary p-1 rounded-pill h3 text-white  my-2" icon="plus" @click="addOption()"/>
      <b-icon class="bg-danger p-1 rounded-pill mx-2 h3 text-white  my-2" icon="trash" @click="deleteQuestion()"/>
    </div>

    <input type="text" class=" form-control" v-model="item.title">

    <div class="form-check form-check-inline" v-for="(option,index) in item.options" @click="setActiveValue(index)">
      <label class="form-check-label mx-2" :for="`${generateHashComputed}_${index}`"> {{ index + 1 }}</label>
      <input :checked="option.value == 1 " class="form-check-input" type="radio"
             :name="generateHashComputed" :id="`${generateHashComputed}_${index}`"
             :value="option.value">
      <input type="text" class="m-2 form-control" v-model="option.label">
      <b-icon class="bg-danger p-1 rounded-pill h3 text-white d-block my-2" icon="trash" @click="deletedOption(index)"/>
    </div>
  </div>
</template>

<script>
import {generateHash} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/ShoppingCart";

export default {
  name: "RadioBoxInput",
  props: {
    item: {}
  },
  computed: {
    generateHashComputed() {
      return generateHash()
    }
  },
  methods: {
    setActiveValue(index) {

      this.item.options.forEach(item => {
        item['value'] = 0
      })

      this.item.options[index]['value'] = 1
    },
    addOption() {
      let countOptions = this.item.options.length
      this.item.options.push({
        "id": (countOptions + 1),
        "label": "ایتم",
        "value": 0
      })
      this.$forceUpdate()
    },
    deletedOption(index) {
      if (confirm('آیا از حذف ایتم اطمینان دارید؟')) {
        this.item.options.splice(index, 1)
        this.$forceUpdate()
      }
    },
    deleteQuestion() {
      this.$emit('removeQuestion')
    }
  },
}
</script>


<style scoped>

</style>